<template>
  <div class="bg-light-gray px-4">
    <div class="row">
      <div class="col-12 mb-3 ">
        <icon-view
          :has-border="false"
          icon="fas fa-calendar-alt text-orange"
          icon-size="17px"
          variant="custom-icon-view"
          icon-background="white"
          title="Coordinar Actividad"
        />
      </div>
    </div>
    <validation-observer ref="appointmentBaseInfoValidator">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'Favor seleccione la fecha',
            }"
            rules="required"
            name="coordinateActivity.date"
          >
            <custom-date-picker
              required
              :disabled-days="definedTime?.disabledDays.split(',')"
              v-model="coordinateActivity.date"
              label="Fecha:"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-container"
              :container-class="'w-100'"
              :error="errors[0]"
              :min-date="getMinDate"
              :custom-error-msg.sync="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'Favor seleccionar hora desde',
            }"
            rules="required"
            name="coordinateActivity.timeFrom"
          >
            <custom-time-picker
              label="Desde:"
              v-model="coordinateActivity.timeFrom"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              ref="fromHour"
            />
          </validation-provider>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 mt-2">
          <validation-provider
            v-slot="{ errors, failedRules }"
            :rules="`required|timeGreaterThan:${coordinateActivity.timeFrom}`"
            name="coordinateActivity.timeTo"
          >
            <custom-time-picker
              label="Hasta:"
              v-model="coordinateActivity.timeTo"
              :error="errors[0]"
              :custom-error-msg="
                failedRules['timeGreaterThan']
                  ? 'La hora hasta debe ser mayor que la hora de inicio.'
                  : 'La hora hasta es requerida.'
              "
            />
          </validation-provider>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'Favor seleccionar tipo de actividad',
            }"
            rules="required"
            name="coordinateActivity.activityType"
          >
            <custom-drop-down
              v-model="coordinateActivity.activityType"
              label="Tipo de Actividad:"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="activities"
              placeholder="Seleccione"
              :custom-error-msg.sync="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-4 col-sm-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'Favor seleccionar nombre de actividad',
            }"
            rules="required"
            name="coordinateActivity.activityName"
          >
            <custom-input
              v-model="coordinateActivity.activityName"
              label="Nombre de Actividad:"
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'Favor seleccionar lugar',
            }"
            rules="required"
            name="coordinateActivity.caatId"
          >
            <custom-drop-down
              v-model="coordinateActivity.caatId"
              label="Lugar:"
              :error="errors[0]"
              :options="caats"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :custom-error-msg.sync="errors[0]"
            />
          </validation-provider>
        </div>
        <div
          v-if="isFollowUp(coordinateActivity.activityType?.id)"
          class="col-lg-3 col-md-4 col-sm-12 mt-2"
        >
          <validation-provider
            v-slot="{ errors }"
            :custom-messages="{
              required: 'Favor seleccionar número de referido',
            }"
            rules="required"
          >
            <custom-auto-complete
              label="Número de Referido:"
              v-model="referralNumber"
              ref="referralAutocompleteRef"
              placeholder="Escriba Número de Referido"
              v-on="$listeners"
              :debounce-time="2000"
              :get-result-value="getReferralResultValue"
              :search="searchReferralAutoCompleteHandler"
              :class="'w-100'"
              @changed="handleOnReferralChange"
              @submit="handleReferralSubmit"
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>

    <div class="row ">
      <div class="col-lg-6 col-md-6 col-sm-12 mt-2">
        <custom-auto-complete
          v-model="coordinateActivity.participant"
          label="Participantes(s):"
          ref="autocompleteRef"
          placeholder="Escriba Nombre del Participante o Número de Referido"
          v-on="$listeners"
          :debounce-time="2000"
          :get-result-value="getResultValue"
          :search="searchAutoCompleteHandler"
          :class="'w-100'"
          @changed="handleOnChange"
          @submit="handleSubmit"
        />
      </div>

      <div class="col-lg-4 pt-2 col-md-6 col-sm-12 mt-2">
        <action-button
          class="mt-4"
          variant="success"
          :i="`fas fa-file-plus pr-1`"
          @click="addParticipantToList"
          :disabled="
            searchParticipantSnapshot.fullName == null ||
              searchParticipantSnapshot.fullName == undefined
          "
        >
          Añadir Participante
        </action-button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-3 ">
        <icon-view
          class="mt-4"
          :has-border="false"
          icon="fas fa-user-alt text-orange"
          icon-size="17px"
          variant="custom-icon-view"
          icon-background="white"
          title="Participantes"
        />
      </div>
    </div>
    <div class="row p-2 pt-0">
      <div
        v-for="(participant, index) in selectedParticipantsList"
        class="bg-white p-3 m-2 col-md-3"
        :key="index"
      >
        <div class="text-right">
          <span
            @click="
              removeParticipantFromList(
                participant.userId,
                participant.atServiceId
              )
            "
            class="cursor-pointer"
          >
            x
          </span>
        </div>
        <strong>{{ participant.fullName }}</strong>
        <p class="mt-2">
          {{
            participant.isReferral ? participant.sieId : participant.userName
          }}
          {{ participant.isReferral ? '/' + participant.referralId : '' }}
        </p>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-end w-100 pr-3 pb-4">
      <action-button
        id="btnCancel"
        variant="outline-danger mr-2"
        type="button"
        i="fas fa-times-circle"
        @click="hideCoordinateActivitySection()"
      >
        Cancelar
      </action-button>
      <action-button
        id="btnAdd"
        variant="success"
        i="fas fa-calendar-alt"
        :disabled="allowcoordinateActivity"
        @click="handlecoordinateActivity()"
      >
        Coordinar
      </action-button>
    </div>
  </div>
</template>

<script>
const activityTypes = Object.freeze({ TRAINING: 2, FOLLOWUP: 10 });
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import { CustomAutoComplete } from '@/components/common';
import CustomTimePicker from '@/components/common/CustomTimePicker.vue';
import CustomDatePicker from '@/components/common/form/CustomDatePicker.vue';
import mixAlert from '@/mixins/alert.mixin';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import locationService from '@/services/api/location.api';
import appointmentcalendarService from '@/services/api/appointmentcalendar.api';
import utils from '@/utils/utilities';

export default {
  components: {
    ActionButton,
    CustomDropDown,
    CustomAutoComplete,
    CustomTimePicker,
    CustomDatePicker,
    IconView,
    CustomInput,
  },
  mixins: [mixAlert],
  props: {
    referral: {
      type: Object,
      default: () => ({}),
    },
    definedTime: {
      type: Object,
      default: () => null,
    },
    activities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      caats: [],
      referralNumber: null,
      caat: null,
      coordinateActivity: {
        date: null,
        timeFrom: null,
        timeTo: null,
        participant: null,
        caat: {},
      },
      searchParticipantSnapshot: {
        data: [],
      },
      specialistsFiltered: [],
      specialistsCaatsFiltered: [],
      selectedParticipantsList: [],
      searchResponse: [],

      searchReferralSnapshot: {
        data: [],
      },
      referralsFiltered: [],
      selectedReferralsList: [],
      referralsSearchResponse: [],
    };
  },
  computed: {
    allowcoordinateActivity() {
      return this.selectedParticipantsList.length == 0;
    },
    getMinDate() {
      return utils.yesterday();
    },
  },
  async mounted() {
    await this.getCaats();
  },
  methods: {
    clearReferralSearchModel() {
      this.searchReferralSnapshot = {
        data: [],
      };
      this.specialistsCaatsFiltered = [];
      this.referralsFiltered = [];
      this.referralNumber = null;
      this.$refs.referralAutocompleteRef.onClearHandler();
    },
    getReferralResultValue(result) {
      return result.referralNumber;
    },
    async handleReferralSubmit(val) {
      this.searchReferralSnapshot.input = val.fullName;
      this.searchReferralSnapshot.referralNumber = val.referralNumber;
      this.searchReferralSnapshot.studentSie = val.studentSie;
      this.searchReferralSnapshot.serviceId = val.serviceId;
      this.referralNumber = val.referralNumber;
    },
    handleOnReferralChange(val) {
      this.referralNumber = val.referralNumber;
      if (!val) {
        this.searchReferralSnapshot.input = null;
      }
    },
    searchReferralAutoCompleteHandler(input) {
      return new Promise((resolve) => {
        if (input.length < 4) {
          return resolve([]);
        }

        if (input == this.searchReferralSnapshot.input) {
          return resolve(this.searchReferralSnapshot.data);
        }
        this.searchReferralSnapshot.input = input;
        appointmentcalendarService
          .getReferralByNumber(input)
          .then(({ data: response }) => {
            this.referralsFiltered = [];
            this.searchReferralSnapshot.data = response.map((item) => ({
              ...item,
              fullName: item.fullName,
              sub1: item.referralNumber,
              sub2: item.studentSie,
            }));
            resolve(this.searchReferralSnapshot.data);
          });
      });
    },
    isFollowUp(val) {
      return val == activityTypes.FOLLOWUP;
    },
    async handlecoordinateActivity() {
      var isValid = await this.$refs.appointmentBaseInfoValidator.validate();
      if (!isValid) {
        return false;
      }
      if (this.selectedParticipantsList.length == 0) {
        this.ShowToast(
          'Alerta',
          'Para coordinar una cita, debe seleccionar al menos un participante.',
          'error'
        );
        this.clearSearchModel();
        return false;
      }

      var payload = {
        referralId: this.isFollowUp(this.coordinateActivity.activityType?.id)
          ? this.searchReferralSnapshot.serviceId
          : null,
        date: this.coordinateActivity.date,
        timeFrom: this.coordinateActivity.timeFrom,
        timeTo: this.coordinateActivity.timeTo,
        name: this.coordinateActivity.activityName,
        activityTypeId: this.coordinateActivity.activityType.id,
        caatId: this.coordinateActivity.caatId?.id,
        participants: this.selectedParticipantsList.map((item) => ({
          userId: item.userId,
          referralId: item.atServiceId == 0 ? null : item.atServiceId,
        })),
      };
      appointmentcalendarService
        .coordinateActivity(payload)
        .then(async () => {
          this.selectedTemplateTabIndex = null;
          this.referral.isOpen = false;
          this.ShowToast('', 'Actividad coordinada exitosamente.', 'success');
          this.clearModel();
          this.clearSearchModel();
          await this.$refs.appointmentBaseInfoValidator.reset();
          this.$emit('save');
          this.$emit('close');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    clearModel() {
      this.coordinateActivity = {
        date: null,
        timeFrom: null,
        timeTo: null,
        participants: [],
        caat: {},
      };
    },
    clearSearchModel() {
      this.searchParticipantSnapshot = {
        data: [],
      };
      this.specialistsCaatsFiltered = [];
      this.specialistsFiltered = [];
      this.caat = null;
      this.$refs.autocompleteRef.onClearHandler();
    },
    addParticipantToList() {
      if (
        this.selectedParticipantsList.some(
          (x) =>
            x.userId == this.searchParticipantSnapshot.userId &&
            x.atServiceId == this.searchParticipantSnapshot.atServiceId &&
            x.fullName == this.searchParticipantSnapshot.fullName &&
            x.role == this.searchParticipantSnapshot.role &&
            x.company == this.searchParticipantSnapshot.company &&
            x.userName == this.searchParticipantSnapshot.userName &&
            x.referralId == this.searchParticipantSnapshot.referralId &&
            x.sieId == this.searchParticipantSnapshot.sieId
        )
      ) {
        this.ShowToast(
          'Alerta',
          'El participante ya se encuentra en la lista.',
          'error'
        );
        this.clearSearchModel();
        return false;
      }
      this.selectedParticipantsList.push({
        fullName: this.searchParticipantSnapshot.fullName,
        userId: this.searchParticipantSnapshot.userId,
        atServiceId: this.searchParticipantSnapshot.atServiceId,
        company: this.searchParticipantSnapshot.company,
        userName: this.searchParticipantSnapshot.userName,
        role: this.searchParticipantSnapshot.role,
        sieId: this.searchParticipantSnapshot.sieId,
        referralId: this.searchParticipantSnapshot.referralId,
        isReferral: this.searchParticipantSnapshot.isReferral,
      });
      this.clearSearchModel();
    },
    removeParticipantFromList(userId, atServiceId) {
      this.selectedParticipantsList = this.selectedParticipantsList.filter(
        (x) =>
          (x.isReferral && x.atServiceId != atServiceId) ||
          (!x.isReferral && x.userId != userId)
      );
    },
    getResultValue(result) {
      return result.fullName;
    },
    async handleSubmit(val) {
      this.coordinateActivity.participant = val.fullName;
      this.searchParticipantSnapshot.input = val.fullName;
      this.searchParticipantSnapshot.fullName = val.fullName;
      this.searchParticipantSnapshot.role = val.role;
      this.searchParticipantSnapshot.userId = val.userId;
      this.searchParticipantSnapshot.atServiceId = val.atServiceId;
      this.searchParticipantSnapshot.company = val.company;
      this.searchParticipantSnapshot.userName = val.userName;
      this.searchParticipantSnapshot.sieId = val.sieId;
      this.searchParticipantSnapshot.referralId = val.referralId;
      this.searchParticipantSnapshot.isReferral = val.isReferral;
      this.specialistsCaatsFiltered = [];
    },
    handleOnChange(val) {
      this.coordinateActivity.participant = val.fullName;
      if (!val) {
        this.searchParticipantSnapshot.input = null;
      }
    },
    searchAutoCompleteHandler(input) {
      return new Promise((resolve) => {
        if (input.length < 4) {
          return resolve([]);
        }

        if (input == this.searchParticipantSnapshot.input) {
          return resolve(this.searchParticipantSnapshot.data);
        }
        this.searchParticipantSnapshot.input = input;
        appointmentcalendarService
          .getActivitiyParticipants(input)
          .then(({ data: response }) => {
            this.specialistsFiltered = [];
            this.searchResponse = response;

            response.forEach((element) => {
              this.specialistsFiltered.push({
                fullName: element.fullName,
                userId: element.userId,
                atServiceId: element.atServiceId,
                company: element.company,
                userName: element.userName,
                role: element.role,
                sieId: element.sieId,
                referralId: element.referralId,
                isReferral: element.isReferral,
              });
            });

            this.searchParticipantSnapshot.data = this.specialistsFiltered.map(
              (item) => ({
                ...item,
                fullName: item.fullName,
                sub1: item.isReferral ? item.sieId : item.userName,
                sub2: item.isReferral ? item.referralId : '',
              })
            );
            resolve(this.searchParticipantSnapshot.data);
          });
      });
    },
    hideCoordinateActivitySection() {
      this.$emit('close');
    },

    async getCaats() {
      const { data: caats } = await locationService.getCaats();
      this.caats = caats;
      if (this.caats.length == 1) {
        this.caat = this.caats[0];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div.custom-callout div.bg-secondary-3 {
  border-bottom: solid #ffffff 2px !important;
}
::v-deep .width-container {
  width: 100% !important;
}

.custom-datetime-picker-container ::v-deep .menu-right {
  right: auto !important;
}
::v-deep .dot {
  padding: 19px !important;
}
</style>
